<template>
  <input
    ref="captchaInput"
    name="v3_captcha_token"
    type="hidden"
  >
</template>

<script>
import recaptchaHelper from '@d-shared/helpers/recaptcha-helper/recaptcha-helper';

export default {
  props: {
    formId: {
      type: String,
      required: true,
    },
    recaptchaV3Key: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    formEl: null,
  }),
  beforeDestroy() {
    this.formEl.removeEventListener('submit', this.submit);
  },
  mounted() {
    this.setupForm();
    this.setupRecaptcha();
  },
  methods: {
    setupForm() {
      const formEl = document.getElementById(this.formId);
      this.formEl = formEl;
      this.formEl.addEventListener('submit', this.submit);
    },

    setupRecaptcha() {
      recaptchaHelper.setup(this.recaptchaV3Key);
    },

    async submit(ev) {
      ev.preventDefault();

      const recaptchaV3Token = await recaptchaHelper.getTokenV3(this.recaptchaV3Key);
      if (!recaptchaV3Token) {
        this.$errorHandler.log('FormRecaptcha submit: could not get V3 token.');
      }

      this.$refs.captchaInput.value = recaptchaV3Token;
      this.formEl.submit();
    },
  },
};
</script>
